/**
 * Ein einziger Bildtakt für alles, was eine Referenz abliest.
 *
 * WARUM NICHT JEDER FÜR SICH. Auf der Simulationsseite stehen acht Diagramme,
 * und jedes muss die Abspielmarke sechzigmal je Sekunde nachziehen. Acht eigene
 * `requestAnimationFrame`-Schleifen wären acht Rückrufe, acht Abbruchpfade und
 * acht Gelegenheiten, eine davon beim Ausbauen einer Karte stehenzulassen. Sie
 * liefen ausserdem nicht garantiert im selben Bild — zwei Marken, die um eine
 * Bildlänge auseinanderstehen, sind auf einem Schirm nebeneinander sichtbar.
 *
 * DIE SCHLEIFE LÄUFT NUR, SOLANGE JEMAND ZUHÖRT. Ohne Zuhörer wird sie
 * abgemeldet; die Diagrammseite kostet im Ruhezustand nichts.
 *
 * Ein Fehler in einem Zuhörer darf die anderen nicht mitreissen — sonst
 * bliebe die halbe Seite stehen, weil ein einzelnes Diagramm gerade zwischen
 * zwei Renderdurchläufen hängt.
 */

type Listener = () => void

const listeners = new Set<Listener>()
let handle: number | null = null

function tick() {
  handle = requestAnimationFrame(tick)
  for (const fn of listeners) {
    try {
      fn()
    } catch {
      /* Absichtlich still: siehe oben. */
    }
  }
}

/** Meldet einen Zuhörer an und gibt die Abmeldung zurück. */
export function onFrame(fn: Listener): () => void {
  listeners.add(fn)
  if (handle === null) handle = requestAnimationFrame(tick)
  return () => {
    listeners.delete(fn)
    if (listeners.size === 0 && handle !== null) {
      cancelAnimationFrame(handle)
      handle = null
    }
  }
}
